var map = {
	"./kz/altel.json": 3898,
	"./kz/default.json": 6285,
	"./kz/tele2.json": 4630,
	"./ru/altel.json": 4158,
	"./ru/default.json": 513,
	"./ru/tele2.json": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9874;